import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import messages from 'aurora-translations';
import WorkflowStepper from './Stepper';
import styles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

function ADGMWorkflowV2(props) {
  const {
    classes,
    loading,
    workflow: { steps, panels },
    currentStep,
    handleNext,
    handleBack,
  } = props;
  const [dialogueOpen, setDialogueOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  const isLastStep = useMemo(() => currentStep === steps?.length, [currentStep, steps]);
  const isFirstStep = useMemo(() => currentStep === 1, [currentStep, steps]);

  const handleDialogue = useCallback(() => {
    if (currentStep === 1) {
      setDialogueOpen(true);
      return;
    }
    handleBack && handleBack();
  }, [currentStep]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <WorkflowStepper steps={steps} currentStep={currentStep} handleNext={handleNext} handleBack={handleBack} />
        </Grid>
        <Grid item xs={12} md={9}>
          <div className={classes.panels}>
            {panels.map(panel => {
              const { Component: Panel, isVisible, attributes, ...panelProps } = panel;
              if (!isVisible) return null;
              return (
                <Panel {...panelProps}>
                  {attributes.map(attr => {
                    const {
                      Component: Attribute,
                      id,
                      order,
                      isFullWidth,
                      isVisible: isAttrVisible,
                      borderTop,
                      ...attrProps
                    } = attr;
                    if (!isAttrVisible) return null;
                    return (
                      <div
                        style={{ order }}
                        key={id}
                        className={classNames({
                          [classes.gridItemFullWidth]: isFullWidth,
                          [classes.borderTop]: borderTop,
                        })}
                      >
                        <Attribute {...attrProps} />
                      </div>
                    );
                  })}
                </Panel>
              );
            })}
          </div>
          {!isEmpty(steps) && (
            <div className={classes.navigatorContainer}>
              <Button disabled={loading || !steps} onClick={handleDialogue} className={classes.backButton}>
                {isFirstStep ? <FormattedMessage {...messages.cancel} /> : <FormattedMessage {...messages.previous} />}
              </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={handleNext}
                className={classes.nextButton}
                disabled={loading}
              >
                {isLastStep ? <FormattedMessage {...messages.submit} /> : <FormattedMessage {...messages.next} />}
              </Button>
            </div>
          )}
          <Dialog
            open={dialogueOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setDialogueOpen(false)}
            disableScrollLock
            aria-labelledby='discard-application'
            aria-describedby='confirmation-discard-application'
          >
            <DialogTitle id='discard-application'>
              <FormattedMessage {...messages.are_you_sure} />
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='confirmation-discard-application'>
                <FormattedMessage {...messages.all_the_data_you_have_entered_in_this_form_will_be_discarded} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setDialogueOpen(false)} color='secondary'>
                <FormattedMessage {...messages.cancel} />
              </Button>
              <Button onClick={handleBack} color='primary'>
                <FormattedMessage {...messages.okay} />
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </Grid>
    </>
  );
}

ADGMWorkflowV2.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  workflow: PropTypes.object.isRequired,
  currentStep: PropTypes.number,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
};

ADGMWorkflowV2.defaultProps = {
  currentStep: 1,
};

export default withStyles(styles)(ADGMWorkflowV2);
